import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, ProductSearchPage, SearchConfig, OccProductSearchAdapter, ConverterService, PRODUCT_SEARCH_PAGE_NORMALIZER} from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable()
export class UigProductSearchAdapter extends OccProductSearchAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {
    super (http, occEndpoints, converter);
  }

  productSearch(
    query: string,
    searchConfig?: SearchConfig
  ): Observable<ProductSearchPage> {
    const url = this.occEndpoints.buildUrl('productSearch', {
      queryParams: { query, ...searchConfig },
    });
    return this.http
        .get(url)
        .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER));
  }

}
